type TokenGetter = (() => Promise<string | null>) | null

let tokenGetter: TokenGetter = null

export function setAuthTokenGetter(getter: TokenGetter): void {
  tokenGetter = getter
}

export async function getAccessToken(): Promise<string | null> {
  if (!tokenGetter) {
    return null
  }

  try {
    return await tokenGetter()
  } catch (error) {
    console.warn('Failed to retrieve Auth0 access token', error)
    return null
  }
}

export async function buildAuthHeaders(
  baseHeaders: Record<string, string> = {},
): Promise<Record<string, string>> {
  const headers = { ...baseHeaders }
  const token = await getAccessToken()
  if (token) {
    headers.Authorization = `Bearer ${token}`
  }

  return headers
}
